<template>
  <el-dialog
    :visible.sync="isShowDialog" class="dialog-square"
    :title="currentItem['name'+_lang]" center width="800px"
    :close-on-click-modal="false" @close="whenDialogClose">
    <div class="dialog-con df-l-c-fs w100p">
      <div class="dialog-ctr w100p">

        <div class="mydialog df-l-c-fs" slot="content">
          <div class="spec-box w100p">
            <div class="spec w100p" v-for="(x3,i3) in currentItem.itemDetailList" :key="i3">
              <div class="spec-tit f-gray df-c-sb">
                <span class="f-s">{{x3['name'+_lang]}}</span>
                <span :class="{'_redcolor':x3.checkedNum<x3.minSelect}">{{x3.specLimitText}}</span>
              </div>
              <div class="spec-con">
                <div
                  v-for="(x4,i4) in x3.nameAndPriceList" :key="i4"
                  class="spec-item df-sb" @click="dialogSpec_selectSpec(x3,x4)"
                  :class="{
                    'spec-item-warning':x3.showWarning,
                    '_be':x3.multi&&x3.checkedNum&&x3.checkedNum===x3.maxSelect,
                  }">
                  <div class="imgbox mr20" style="padding:10px 0">
                    <img
                      style="width:20px;height:20px;" mode="aspectFill"
                      :src="x3.multi
                        ?(x4.select?iconCheckok:iconChecknull)
                        :(x4.select?iconCheckok2:iconChecknull2)" />
                  </div>
                  <div class="spec-item-title f-s f-gray f1" :class="{'_c9':x3.multi&&x3.checkedNum&&x3.checkedNum===x3.maxSelect}">{{x4['name'+_lang]}}</div>
                  <div class="spec-item-price f-s f-gray" :class="{'_c9':x3.multi&&x3.checkedNum&&x3.checkedNum===x3.maxSelect}" v-if="!currentItem.realPriceItem">{{x4.price|toprice(2,true)}}</div>
                </div>
              </div>
            </div>
          </div>

          <div class="btm w100p df-fe-sb">
            <!-- 下左 -->
            <div class="left">
              <div class="item w100p df-fs ai-fs">
                <span class="lable f-xxs df-c-ct">{{$t('menu.selectSpec')}}：</span>
                <span class="f1">{{spec_specItems}}</span>
              </div>
              <div class="item f-xxxs w100p f-silvery">{{spec_priceItems}}</div>
            </div>
            <!-- 下右 -->
            <div class="right sls">
              <div class="price-box sls df-c-fe f1">
                <span class="f-s">{{$t('common.total')}}：</span>
                <span class="f-xl _redcolor sls" v-if="currentItem.realPriceItem">{{$t('menu.timePrice')}}</span>
                <span class="f-xl _redcolor sls" v-else>{{spec_totalPrice|toprice(2)}}</span>
              </div>
              <div class="df-c-fe">
                <div :class="{'themebtn':submitBtnOk,'whitebtn':!submitBtnOk,'themebtn-en':lang==='en'}" @click="dialogSubmit(true)" class="mr10" v-if="showRefreshAndSend">{{$t('menu.refreshAndSend')}}</div>
                <div :class="submitBtnOk?'themebtn':'whitebtn'" @click="dialogSubmit(false)" v-if="showRefresh">{{$t('menu.refresh')}}</div>
                <div :class="submitBtnOk?'themebtn':'whitebtn'" @click="dialogSubmit(false)" v-if="openFrom==='menu'">{{$t('menu.add')}}</div>
              </div>
            </div>
          </div>
        </div>
          
      </div>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: 'DialogSpec',
  data() {
    return {
      isShowDialog: false,
      
      currentItem: '',
      currentItem_copy: '',

      spec_specItems: '', // 对话框 左下角 已选择菜品
      spec_priceItems: '', // 对话框 左下角 已选择菜品+价格
      spec_totalPrice: '', // 对话框 左下角 总计

      submitBtnOk: false,
      openFrom: '', // cart购物车 menu菜单
    }
  },
  computed: {
    showRefreshAndSend() {
      const BEFORE = JSON.parse(JSON.stringify(this.currentItem_copy))
      const NOW = JSON.parse(JSON.stringify(this.currentItem))
      let result = this.openFrom === 'cart'
        && this.isHasSendCookId
        && this.user_x.privilegeList.includes('sjzhgl_bdcfxgcp')
        && JSON.stringify(BEFORE) !== JSON.stringify(NOW)
      // console.log(
      //   1111,
      //   this.openFrom,
      //   this.isHasSendCookId,
      //   this.user_x.privilegeList.includes('sjzhgl_bdcfxgcp'),
      //   JSON.stringify(this.currentItem),
      //   JSON.stringify(this.currentItem_copy),
      //   result
      // )
      return result
    },
    showRefresh() {
      const BEFORE = JSON.parse(JSON.stringify(this.currentItem_copy))
      const NOW = JSON.parse(JSON.stringify(this.currentItem))
      let result = this.openFrom === 'cart'
        && JSON.stringify(BEFORE) !== JSON.stringify(NOW)
      // console.log(
      //   1111,
      //   this.openFrom,
      //   JSON.stringify(this.currentItem),
      //   JSON.stringify(this.currentItem_copy),
      //   result
      // )
      return result
    },
  },
  methods: {
    open() {
      this.scan_canLeave_x_save(false)
      this.isShowDialog = true
    },
    close() {
      this.isShowDialog = false
    },
    whenDialogClose() {
      this.scan_canLeave_x_save(true)
      this.isShowDialog = false
      this.currentItem = ''
      this.currentItem_copy = ''
      this.spec_specItems = '' // 对话框 左下角 已选择菜品
      this.spec_priceItems = '' // 对话框 左下角 已选择菜品+价格
      this.spec_totalPrice = '' // 对话框 左下角 总计
      this.submitBtnOk = false
      this.openFrom = ''
    },


    // 文本处理
    dialogSpec_textHandle() {
      const RESULT = { val1: '', val2: '', val3: 0}
      RESULT.val2 = this.currentItem['name' + this._lang]
      this.currentItem.realPriceItem ? '' : RESULT.val2 += this.priceFormat(this.currentItem.price)
      this.currentItem.realPriceItem ? '' : RESULT.val3 = this.currentItem.price
      
      if (this.currentItem) {
        this.currentItem.itemDetailList.forEach(x3 => {
          x3.nameAndPriceList.forEach(x4 => {
            x4.select ? RESULT.val1 += x4['name' + this._lang] + '、' : ''
            x4.select && x4.price && !this.currentItem.realPriceItem ? RESULT.val3 += Number(x4.price) : ''
            x4.select && x4.price && !this.currentItem.realPriceItem ? RESULT.val2 += '+' + x4['name' + this._lang] + this.priceFormat(x4.price) : ''
          })
        })
        // #region 对话框 左下角 已选择菜品
        if (RESULT.val1[RESULT.val1.length - 1] === '、') {
          RESULT.val1 = RESULT.val1.substr(0, RESULT.val1.length - 1)
        }
        // #endregion
        // #region 对话框 左下角 已选择菜品+价格
        if (RESULT.val2[RESULT.val2.length - 1] === '、') {
          RESULT.val2 = RESULT.val2.substr(0, RESULT.val2.length - 1)
        }
        // #endregion
      }
      this.spec_specItems = RESULT.val1
      this.spec_priceItems = RESULT.val2
      this.spec_totalPrice = RESULT.val3

      this.dialogSpec__btnOkFunction_select()
    },
    // 按钮禁用处理
    dialogSpec__btnOkFunction_select() {
      let flag = true
      this.currentItem.itemDetailList.forEach(x3 => {
        // console.log(`%cx3:`, 'color: #00f;', x3)
        let { required, checkedNum, minSelect, showWarning } = x3
        let result = required && checkedNum < minSelect
        showWarning && (
          x3.showWarning = result
        )
        result && (flag = false)
      })
      console.log(`%cflag:`, 'color: #00f;', flag)
      this.submitBtnOk = flag
    },
    dialogSpec__btnOkFunction_submit() {
      let flag0 = true
      this.currentItem.itemDetailList.forEach(x3 => {
        // console.log(`%cx3:`, 'color: #00f;', x3)
        let { required, checkedNum, minSelect } = x3
        let flag2 = required && checkedNum < minSelect
        x3.showWarning = flag2
        flag2 && (flag0 = false)
      })
      console.log(`%cflag:`, 'color: #00f;', flag0)
      this.submitBtnOk = flag0
    },

    dialogSpec_selectSpec(item3, item4, index2) {
      console.log(item3, item4)
      console.log(`%cmin-max:`, 'color: #00f;', item3.minSelect, item3.maxSelect, item4.select)

      if (item4.select) {
        item4.select = false
        item3.checkedNum--
      } else {
        if (item3.multi) {
          const LIST_CHECKED = item3.nameAndPriceList.filter(x => x.select)
          if (LIST_CHECKED.length < item3.maxSelect) {
            item4.select = true
            item3.checkedNum++
          } else {
            console.log(`%c已经达到上限了:`, 'color: #00f;')
          }
        } else {
          item3.nameAndPriceList.forEach(x4 => { x4.select = false })
          item4.select = true
          item3.checkedNum = 1
        }
      }
      this.dialogSpec_textHandle()
    },

    // 提交
    dialogSubmit(flag) {
      console.log(`%c当前弹框规格菜:`, 'color: #00f;', this.currentItem, this.currentItem.itemDetailList)

      this.dialogSpec__btnOkFunction_submit()
      
      if (this.submitBtnOk) {
        this.currentItem._price = this.spec_totalPrice
        this.$emit('submit', this.currentItem, flag)
      } else {
        this.$message.warning(this.$t('menu.addItemWarning'))
      }
    },
    
    // 父组件点击了规格菜，打开对话框
    tapSpec(item) {
      this.openFrom = 'menu'
      this.isHasSendCookId = false
      this.specHandle(item.itemDetailList)
      this.currentItem = JSON.parse(JSON.stringify(item))
      console.log(`%c是规格菜-商品詳情:`, 'color: #00f;', this.currentItem, this.currentItem.itemDetailList)
      this.dialogSpec_textHandle()
      this.currentItem_copy = JSON.parse(JSON.stringify(item))
      this.open()
    },
    // 请求回来的菜品处理规格菜列表
    specHandle(specs) {
      specs.forEach(x3 => {
        x3.checkedNum = 0
        x3.showWarning = false
        x3.nameAndPriceList.forEach(x4 => {
          x4.select = false
        })

        // #region 处理规格提示
        let specLimitText = ''
        if (x3.required || x3.minSelect > 0) {
          if (x3.minSelect === x3.maxSelect) {
            specLimitText = this.$t('menu.specLimit1') + this.tothousands(x3.minSelect)
          } else {
            specLimitText = this.$t('menu.specLimit3') + this.tothousands(x3.minSelect) + '-' + this.tothousands(x3.maxSelect)
          }
        } else {
          if (x3.minSelect === x3.maxSelect) {
            specLimitText = this.$t('menu.specLimit2') + this.tothousands(x3.minSelect)
          } else {
            specLimitText = this.$t('menu.specLimit2') + this.tothousands(x3.minSelect) + '-' + this.tothousands(x3.maxSelect)
          }
        }
        x3.specLimitText = specLimitText
        // #endregion
      })
      return specs
    },

    // 修改购物车里的规格菜
    specCartModify(cartItem, newItem, isHasSendCookId) {
      this.openFrom = 'cart'
      this.isHasSendCookId = !!isHasSendCookId
      this.specHandle(newItem.itemDetailList)
      console.log(`%c购物车的规格菜:`, 'color: #00f;', cartItem, cartItem.itemDetailList)
      console.log(`%c菜单的规格菜:`, 'color: #f00;', newItem, newItem.itemDetailList)

      cartItem.itemDetailList.forEach(x3 => {
        const X3 = newItem.itemDetailList.find(x => Number(x.id) === x3.id && !x.done)
        if (X3) {
          X3.done = true
          // X3.checkedNum = x3.nameAndPriceList.length
          const IDS = X3.nameAndPriceList.map(x => x.id)
          const LIST = x3.nameAndPriceList.filter(x => IDS.includes(x.id))
          X3.checkedNum = LIST.length

          x3.nameAndPriceList.forEach(x4 => {
            const X4 = X3.nameAndPriceList.find(x => Number(x.id) === x4.id && !x.done)
            if (X4) {
              X4.done = true
              X4.select = true
            }
          })
        }
      })
      console.log(`%c处理后的规格菜:`, 'color: #f00;', newItem)

      this.currentItem = newItem
      this.dialogSpec_textHandle()
      this.currentItem_copy = JSON.parse(JSON.stringify(newItem))
      this.open()
    },
  },
}
</script>

<style lang="scss" scoped>
@import '@/assets/css/util_dialog.scss';
.mydialog{
  padding: 20px;
  .spec-box{
    height: 380px;overflow: hidden scroll;
    .spec{
      .spec-tit{height: 48px;line-height: 48px;}
      .spec-con{
        .spec-item{
          min-height: 40px;line-height: 28px;padding: 0 10px;margin: 4px 0;border-radius: 10px;
          &-warning{background: #FFEFEE;}
          &-title{word-break: break-word;white-space: normal;padding: 6px 0;}
          &-price{padding: 6px 0 6px 20px;}
        }
      }
    }
  }
  .btm{
    min-height: 80px;padding: 20px 0 10px;
    .left{
      max-width: 50%;
      .item{min-height: 24px;line-height: 24px;}
    }
    .right{
      max-width: 50%;
      .price-box{height: 48px;line-height: 48px;text-align: right;}
      .themebtn-en{font-size: 12px;}
    }
  }
}
</style>